import globalToast from '$$vueCmp/toast';

var innerObject = {
  handlers: {
    helpers: {
      showMessage: function (text, type = 'info', expire) {
        globalToast[type](text, { timeout: expire || 8000 });
      }
    }
  },
  socketData: {
    count: 0
  }
};


var outputObject = {
  show: innerObject.handlers.helpers.showMessage
};

export default outputObject;
